import {
	countClouTalkCalling,
	countRealTimeCalling,
	handleCountNotPickUp,
} from './counters';

export const getRaws = (data) => [
	<tr>
		<td>{data.length}</td>
		<td>{handleCountNotPickUp(data)}</td>
		<td>{countRealTimeCalling(data)}</td>
		<td>{countClouTalkCalling(data)}</td>
	</tr>,
];
